<!-- menuOne  对应 二级导航的样式2  -->
<template>
  <div class="custom-submenu" :style="style" ref="customSubMenu">
    <div class="second-menu" v-for="(menu, index) in menuData" :key="menu.label" :style="secondMenuStyle">
      <div :class="activeIndex === [menuIndex, index].join('_') ? 'second-menu-title is-active' : 'second-menu-title'" @click="handleSubMenuSelect([menuIndex, index])">
        <span v-if="getSecondIconPosition === 'right'" class=" text-overflow" :title="menu.name">{{ menu.label }}</span>
        <cxIcon class="icon" v-if="secondIconSet.iconType === 'icon' && secondIconSet.showIcon !== false"
                :options="secondTitleIcon"
                :iconStyle="secondTitleIconStyle"></cxIcon>
        <img class="icon" v-else-if="secondIconSet.iconType === 'img' && secondIconSet.iconSrc && secondIconSet.showIcon !== false"
             :src="secondIconSet.iconSrc"
             :style="secondTitleIconStyle"/>
        <span v-if="getSecondIconPosition === 'left'" class="text-overflow" :title="menu.name">{{ menu.label }}</span>
      </div>
      <div class="third-menu-container" v-if="menu.children && menu.children.length">
        <div class="third-menu" v-for="(subMenu, subMenuIndex) in menu.children" :key="subMenu.label">
          <p :class="activeIndex === [menuIndex, index, subMenuIndex].join('_') ? 'third-menu-title is-active' : 'third-menu-title'" :title="menu.name" @click="handleSubMenuSelect([menuIndex, index, subMenuIndex])">
            <span v-if="getIconPosition === 'right'"  class="title-content">{{ subMenu.label }}</span>
            <cxIcon class="icon" v-if="iconSet.iconType === 'icon' && iconSet.showIcon !== false" :options="titleIcon" :iconStyle="titleIconStyle"></cxIcon>
            <img class="icon" v-else-if="iconSet.iconType === 'img' && iconSet.iconSrc && iconSet.showIcon !== false" :src="iconSet.iconSrc" :style="titleIconStyle"/>
            <span v-if="getIconPosition === 'left'"  class="title-content">{{ subMenu.label }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { isPlainObject, customUnitTranform, isSsrPage, remCheck } from '@/utils/index'
import defaultProps, { propTypeMap, unitMap } from './defaultProps.js'
import propTrans from './../setting/propTrans.js'
import $ from 'jquery'
export default {
  props: {
    menuIndex: Number,
    menuData: {
      type: Array,
    },
    config: {
      type: Object,
      default: () => Object.create(null)
    }
  },
  data() {
    return {
      leftPos: 0,
      defaultProps: JSON.parse(JSON.stringify(defaultProps)),
      activeIndex: ""
    }
  },
  watch: {
    pageWidth(newVal) {
      this.$nextTick(() => {
        newVal && this.checkLeftPosition()
      })
    },
    zoomActual() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.checkLeftPosition()
        }, 1000)
      })
    },
    navSizeWidth(n) {
      if (n) {
        this.$nextTick(() => {
          this.checkLeftPosition()
        })
      }
    },
    alignType() {
      this.$nextTick(() => {
        this.checkLeftPosition()
      })
    },
    'finalConfig.showConnector': function() {
      this.$eventBus.$emit("updateConnectorStyle")
      this.$nextTick(() => {
        this.checkLeftPosition()
      })
    },
    'finalConfig.connectorWidth': function() {
      this.$eventBus.$emit("updateConnectorStyle")
    },
    'finalConfig.connectorColor': function() {
      this.$eventBus.$emit("updateConnectorStyle")
    },
  },
  computed: {
    secondMenuStyle() {
      if (this.finalConfig?.widthType === 'fixed') {
        return {
          width: this.style['--widthValue']
        }
      } else if (this.finalConfig?.widthType === 'equal') {
        return {
          flex: 1
        }
      }
    },
    alignType() {
      return this.finalConfig?.navSite?.alignmentType
    },
    finalConfig() {
      const config = {...this.defaultProps}
      Object.entries(this.config).forEach(([key, value]) => {
        if (isPlainObject(value) && isPlainObject(config[key])) {
          config[key] = {...config[key], ...value}
        } else if ([Boolean, String, Number].includes(typeof value)) {
          config[key] = value + (unitMap[key] || '')
        } else {
          config[key] = this.config[key] ?? config[key]
        }
      })
      Object.entries(config).forEach(([key, value]) => {
        if (['number', 'string'].includes(typeof value)) {
          config[key] = value + (unitMap[key] || '')
        }
        if (propTrans[propTypeMap[key]]) {
          config[key] = propTrans[propTypeMap[key]](value)
        }
      })
      return config
    },
    style() {
      const styleObject = {}
      Object.entries(this.finalConfig).forEach(([key, value]) => {
        if (isPlainObject(value)) {
          Object.entries(value).forEach(([subKey, value]) => {
            styleObject[`--${key}_${subKey}`] = customUnitTranform(subKey, value)
          })
        } else {
          styleObject[`--${key}`] = customUnitTranform(key, value)
        }
      })
      // styleObject.left = (this?.config?.navSize?.widthFull ? -this.leftPos : 0)  + 'px'
      if (this.finalConfig?.navSize?.width === 'widthCenter') {
        styleObject['--navSize_width'] = this.pageWidth
      }
      return styleObject
    },
    zoomActual() {
      return this.$store.state.states.zoomActual
    },
    showAllScreen() {
      // 开启了适应屏幕宽度
      return !this.$store.state.states.showAllScreen
    },
    navSizeWidth() {
      return this.finalConfig?.navSize?.width
    },
    pageWidth() {
      return remCheck(this.$store.state[this.request_prefix].page.pageWidth) ?? "1920px"
    },
    getIconPosition() {
      return this.iconSet?.iconPosition
    },
    iconSet() {
      return this.finalConfig?.thirdNavIcon
    },
    titleIcon() {
      return {
        iconSrc: this.iconSet.iconSrc,
        iconWidth: this.iconSet.iconWidth,
        iconMargin: this.iconSet.iconMargin,
        iconPosition: this.iconSet.iconPosition
      }
    },
    titleIconStyle() {
      const data = this.iconSet
      return {
        '--color': data.iconColor,
        fontSize: remCheck(data.iconWidth),
        width: remCheck(data.iconWidth),
        height: remCheck(data.iconWidth),
        margin: data.iconPosition === "left"
          ? `0 ${remCheck(data.iconMargin)} 0 0`
          : `0 0 0 ${remCheck(data.iconMargin)}`
      }
    },
    getSecondIconPosition() {
      return this.secondIconSet?.iconPosition
    },
    secondIconSet() {
      return this.finalConfig?.secondNavIcon
    },
    secondTitleIcon() {
      return {
        iconSrc: this.secondIconSet.iconSrc,
        iconWidth: this.secondIconSet.iconWidth,
        iconMargin: this.secondIconSet.iconMargin,
        iconPosition: this.secondIconSet.iconPosition
      }
    },
    secondTitleIconStyle() {
      const data = this.secondIconSet
      return {
        "display": "inline-block",
        "vertical-align": "middle",
        '--color': data.iconColor,
        fontSize: remCheck(data.iconWidth),
        width: remCheck(data.iconWidth),
        height: remCheck(data.iconWidth),
        margin: data.iconPosition === "left"
            ? `0 ${remCheck(data.iconMargin)} 0 0`
            : `0 0 0 ${remCheck(data.iconMargin)}`
      }
    },
  },
  methods: {
    handleSubMenuSelect(pathArr) {
      this.activeIndex = pathArr.join('_')
      this.$emit('subMenuSelect', pathArr.join('_'))
    },
    // checkLeftPosition() {
    //   const parentSubMenuDom = $(this.$refs.customSubMenu).parents('.el-submenu')?.[0]
    //   if (parentSubMenuDom) {
    //     this.leftPos = parentSubMenuDom?.getBoundingClientRect()?.left
    //   }
    // },
    checkLeftPosition() {
      const contentContainer = document.querySelector(".content_p_helper").getBoundingClientRect()
      const originPageWidth = parseFloat(this.pageWidth)
      const parentSubMenuDom = $(this.$refs.customSubMenu).parents(".el-submenu")?.[0]
      const zoom = 1
      const bodyWidth = parseFloat(getComputedStyle(document.body).width)
      let translateLeft = 0
      if (parentSubMenuDom) {
        this.leftPos = parentSubMenuDom?.getBoundingClientRect()?.left
        const width = this.finalConfig?.navSize?.width
        if (width === '100vw') {
          parentSubMenuDom.querySelector(".el-menu--horizontal").classList
            .remove("sub_menu_left", "sub_menu_right", "sub_menu_center")
          translateLeft = - this.leftPos / this.zoomActual
          parentSubMenuDom.querySelector(".el-menu--horizontal").classList.add("full-width-submenu")
        } else if (width === 'widthCenter') {// 充满版心
          parentSubMenuDom.querySelector(".el-menu--horizontal").classList
            .remove("sub_menu_left", "sub_menu_right", "sub_menu_center")
          if (this.showAllScreen) {
            // 说明是未缩放的情况, 按照版心计算来获取偏移值
            translateLeft = (bodyWidth - originPageWidth) / 2 - this.leftPos
          } else {
            // 说明是缩放情况，此时只需要和content_p_helper的中线对齐，就一定是对齐的
            const centerLineLeft = contentContainer.width / 2 + contentContainer.left
            translateLeft = (centerLineLeft - 0.5 * (originPageWidth * this.zoomActual) - this.leftPos) / this.zoomActual
          }
          parentSubMenuDom.querySelector(".el-menu--horizontal").classList.add("full-width-submenu")
        } else {
          parentSubMenuDom.querySelector(".el-menu--horizontal").classList
            .remove("sub_menu_left", "sub_menu_right", "sub_menu_center")
          parentSubMenuDom.querySelector(".el-menu--horizontal").classList.remove("full-width-submenu")
          // parentSubMenuDom.querySelector(".el-menu--horizontal").classList.add('sub_menu_' + this.finalConfig.navPopPosition)
        }
        let ulTop = parseInt(getComputedStyle(parentSubMenuDom).getPropertyValue("--ulTopDefault"))
        parentSubMenuDom.style.setProperty("--ulTop", ulTop)

        if(this.finalConfig.showConnector){
          parentSubMenuDom.querySelector(".el-menu--horizontal").setAttribute("data-connector-top", 25)
        }
        parentSubMenuDom.querySelector(".el-menu--horizontal") &&
          (parentSubMenuDom.querySelector(".el-menu--horizontal").style.transform = `translate(${translateLeft}px, ${this.finalConfig.showConnector ? 25: 0}px)`)

        parentSubMenuDom.querySelector(".el-menu--popup") &&
            (parentSubMenuDom.querySelector(".el-menu--popup").style.background = "transparent")  
        parentSubMenuDom.querySelector(".el-menu--popup") &&
        (parentSubMenuDom.querySelector(".el-menu--popup").style.boxShadow = "none")    
      }
    }
  },
  mounted() {
    if (this?.config?.navSize?.widthFull) {
      // 如果尺寸开启了充满
      this.$emit('setFullSubMenuIndex', this.menuIndex)
    }
    if (!isSsrPage()) {
      this.checkLeftPosition()
    }
  }
}
</script>
<style lang="scss" scoped>
.text-overflow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.custom-submenu {
  width: var(--navSize_width);
  height: var(--navSize_height);
  box-sizing: content-box;
  display: flex;
  gap: var(--navGap);
  padding: var(--navPadding);
  border-style: var(--navBorder_borderStyle);
  border-width: var(--navBorder_borderWidth);
  border-color: var(--navBorder_borderColor) !important;
  border-radius: var(--navBorderRadius);
  background-color: var(--wholeBackground_backgroundColor);
  background-image: var(--wholeBackground_backgroundImage);
  background-repeat: var(--wholeBackground_backgroundRepeat);
  background-position: var(--wholeBackground_backgroundPosition);
  background-size: var(--wholeBackground_backgroundSize);
  box-shadow: var(--navBoxShadow);
  font-family: "PingFang SC";
  position: relative;
  //justify-content: center
  justify-content: var(--navSite_alignmentType);
}
.second-menu {
  flex-shrink: 0;
  overflow: hidden;
}
.second-menu-title {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  font-size: var(--secondNavTitle_fontSize);
  font-weight: var(--secondNavTitle_fontWeight);
  line-height: var(--secondNavTitle_lineHeight);
  text-align: var(--secondNavTitle_textAlign);
  letter-spacing: var(--secondNavTitle_letterSpacing);
  text-decoration: var(--secondNavTitle_textDecoration);
  font-style: var(--secondNavTitle_fontStyle);
  color: var(--secondNavTitle_fontColor);
  writing-mode: var(--secondNavTitle_writingMode);
  border-width: var(--secondNavTitleBorder_borderWidth);
  border-color: var(--secondNavTitleBorder_borderColor) !important;
  border-style: var(--secondNavTitleBorder_borderStyle);
  padding: var(--secondNavPadding);
  background-repeat: var(--secondNavTitleBackground_backgroundRepeat);
  background-image: var(--secondNavTitleBackground_backgroundImage);
  background-color: var(--secondNavTitleBackground_backgroundColor);
  background-size: var(--secondNavTitleBackground_backgroundSize);
  background-position: var(--secondNavTitleBackground_backgroundPosition);
  border-radius: var(--secondRadius);
  cursor: pointer;
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0px;
    right: 0;
    border-bottom-width: var(--secondTitleBorderWidth);
    border-bottom-style: solid;
    border-bottom-color: var(--secondTitleBorderColor);
  }
  &:hover {
    padding: var(--secondNavHoverPadding);
    font-size: var(--secondNavHoverTitle_fontSize);
    font-weight: var(--secondNavHoverTitle_fontWeight);
    line-height: var(--secondNavHoverTitle_lineHeight);
    text-align: var(--secondNavHoverTitle_textAlign);
    letter-spacing: var(--secondNavHoverTitle_letterSpacing);
    text-decoration: var(--secondNavHoverTitle_textDecoration);
    font-style: var(--secondNavHoverTitle_fontStyle);
    color: var(--secondNavHoverTitle_fontColor);
    writing-mode: var(--secondNavHoverTitle_writingMode);
    border-width: var(--secondNavTitleHoverBorder_borderWidth);
    border-color: var(--secondNavTitleHoverBorder_borderColor) !important;
    border-style: var(--secondNavTitleHoverBorder_borderStyle);
    border-radius: var(--secondHoverRadius);
    background-repeat: var(--secondHoverNavTitleBackground_backgroundRepeat);
    background-image: var(--secondHoverNavTitleBackground_backgroundImage);
    background-color: var(--secondHoverNavTitleBackground_backgroundColor);
    background-size: var(--secondHoverNavTitleBackground_backgroundSize);
    background-position: var(--secondHoverNavTitleBackground_backgroundPosition);
  }
  &.is-active {
    padding: var(--secondNavActivePadding);
    font-size: var(--secondNavActiveTitle_fontSize);
    font-weight: var(--secondNavActiveTitle_fontWeight);
    line-height: var(--secondNavActiveTitle_lineHeight);
    text-align: var(--secondNavActiveTitle_textAlign);
    letter-spacing: var(--secondNavActiveTitle_letterSpacing);
    text-decoration: var(--secondNavActiveTitle_textDecoration);
    font-style: var(--secondNavActiveTitle_fontStyle);
    color: var(--secondNavActiveTitle_fontColor);
    writing-mode: var(--secondNavActiveTitle_writingMode);
    border-width: var(--secondNavTitleActiveBorder_borderWidth);
    border-color: var(--secondNavTitleActiveBorder_borderColor) !important;
    border-style: var(--secondNavTitleActiveBorder_borderStyle);
    border-radius: var(--secondActiveRadius);
    background-repeat: var(--secondActiveNavTitleBackground_backgroundRepeat);
    background-image: var(--secondActiveNavTitleBackground_backgroundImage);
    background-color: var(--secondActiveNavTitleBackground_backgroundColor);
    background-size: var(--secondActiveNavTitleBackground_backgroundSize);
    background-position: var(--secondActiveNavTitleBackground_backgroundPosition);
  }
}
.third-menu-container {
  padding-top: 10px;
  .third-menu {
    &:not(:last-child) {
      margin-bottom: var(--thirdNavTitleMargin);
    }
  }
}
.third-menu-title {
  width: 100%;
  margin: 0;
  line-height: var(--thirdNavTitle_lineHeight);
  text-align: var(--thirdNavTitle_textAlign);
  font-size: var(--thirdNavTitle_fontSize);
  font-weight: var(--thirdNavTitle_fontWeight);
  color: var(--thirdNavTitle_fontColor);
  letter-spacing: var(--thirdNavTitle_letterSpacing);
  text-decoration: var(--thirdNavTitle_textDecoration);
  font-style: var(--thirdNavTitle_fontStyle);
  writing-mode: var(--thirdNavTitle_writingMode);
  padding: var(--thirdNavPadding);
  border-width: var(--thirdTitleBorder_borderWidth);
  border-color: var(--thirdTitleBorder_borderColor) !important;
  border-style: var(--thirdTitleBorder_borderStyle);
  border-radius: var(--thirdTitleRadius);
  background-repeat: var(--thirdNavTitleBackground_backgroundRepeat);
  background-image: var(--thirdNavTitleBackground_backgroundImage);
  background-color: var(--thirdNavTitleBackground_backgroundColor);
  background-size: var(--thirdNavTitleBackground_backgroundSize);
  background-position: var(--thirdNavTitleBackground_backgroundPosition);
  cursor: pointer;
  .title-content {
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    -webkit-line-clamp: var(--thirdNavTitleLines);
    -webkit-box-orient: vertical;
  }
  .icon {
    flex-shrink: 0;
  }
  &:hover {
    text-align: var(--thirdHoverNavTitle_textAlign);
    font-size: var(--thirdHoverNavTitle_fontSize);
    font-weight: var(--thirdHoverNavTitle_fontWeight);
    color: var(--thirdHoverNavTitle_fontColor);
    letter-spacing: var(--thirdHoverNavTitle_letterSpacing);
    text-decoration: var(--thirdHoverNavTitle_textDecoration);
    font-style: var(--thirdHoverNavTitle_fontStyle);
    writing-mode: var(--thirdHoverNavTitle_writingMode);
    background-repeat: var(--thirdHoverNavTitleBackground_backgroundRepeat);
    background-image: var(--thirdHoverNavTitleBackground_backgroundImage);
    background-color: var(--thirdHoverNavTitleBackground_backgroundColor);
    background-size: var(--thirdHoverNavTitleBackground_backgroundSize);
    background-position: var(--thirdHoverNavTitleBackground_backgroundPosition);
    border-radius: var(--thirdHoverRadius);
    border-width: var(--thirdTitleHoverBorder_borderWidth);
    border-color: var(--thirdTitleHoverBorder_borderColor) !important;
    border-style: var(--thirdTitleHoverBorder_borderStyle);
  }
  &.is-active {
    text-align: var(--thirdActiveNavTitle_textAlign);
    font-size: var(--thirdActiveNavTitle_fontSize);
    font-weight: var(--thirdActiveNavTitle_fontWeight);
    color: var(--thirdActiveNavTitle_fontColor);
    letter-spacing: var(--thirdActiveNavTitle_letterSpacing);
    text-decoration: var(--thirdActiveNavTitle_textDecoration);
    font-style: var(--thirdActiveNavTitle_fontStyle);
    writing-mode: var(--thirdActiveNavTitle_writingMode);
    background-repeat: var(--thirdActiveNavTitleBackground_backgroundRepeat);
    background-image: var(--thirdActiveNavTitleBackground_backgroundImage);
    background-color: var(--thirdActiveNavTitleBackground_backgroundColor);
    background-size: var(--thirdActiveNavTitleBackground_backgroundSize);
    background-position: var(--thirdActiveNavTitleBackground_backgroundPosition);
    border-radius: var(--thirdActiveRadius);
    border-width: var(--thirdTitleActiveBorder_borderWidth);
    border-color: var(--thirdTitleActiveBorder_borderColor) !important;
    border-style: var(--thirdTitleActiveBorder_borderStyle);
  }
}
</style>
